import { createSonarSelector } from '@lib/selectors';
import { useSonarSelector } from '@hooks/useSonarSelector';

const selector = createSonarSelector((state) => Boolean(state.application.maintenance.read.data?.locked));

export function useMaintenanceMode(): boolean {
	return useSonarSelector(selector);
}
